import React, { useEffect } from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import TestimonialsSection from '../components/TestimonialsSection';
import ServicesSection from '../components/ServicesSection';
import CitiesSection from '../components/CitiesSection';
import Footer from '../components/Footer';

const HomePage = () => {
  useEffect(() => {
    document.title = 'Marabout Voyant Medium à Bruxelles - Retour Affectif Rapide | 24/7';
    
    // SEO Meta tags
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Grand marabout africain à Bruxelles. Services de voyance, retour affectif, envoûtement amoureux, permis de construire. Consultations 24/7 à Bruxelles, Ixelles, Schaerbeek, Anderlecht, Molenbeek.');
    }
  }, []);

  return (
    <div className="home-page">
      <Header />
      <HeroSection />
      <AboutSection />
      <TestimonialsSection />
      <ServicesSection />
      <CitiesSection />
      <Footer />
    </div>
  );
};

export default HomePage;
